"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const react_hook_form_1 = require("react-hook-form");
const clsx_1 = __importDefault(require("clsx"));
const common_1 = require("@Const/common");
const utils_1 = require("@App/common/utils");
const FieldErrorSectionForm_1 = __importDefault(require("@App/kit/fields/FieldErrorSectionForm"));
const InputForm = (props) => {
    const { register, watch, setValue } = (0, react_hook_form_1.useFormContext)();
    const [hasFocus, setFocus] = (0, react_1.useState)(false);
    const { name, label, mainColor = true, placeholder, assistiveText, registerOptions, assistiveTextFunction, assistiveTextVisibility, } = props;
    (0, react_1.useEffect)(() => {
        setFocus((0, utils_1.doesFieldHaveFocus)(name));
    }, []);
    const classNamesForOuterDiv = (0, clsx_1.default)('input-form-component', mainColor ? 'main-color-set' : 'second-color-set', 'submit', hasFocus && 'focused');
    const watchName = watch(name);
    const required = !!registerOptions && !!registerOptions.required;
    const displayAssistiveText = assistiveText !== null && assistiveText !== void 0 ? assistiveText : (assistiveTextFunction ? assistiveTextFunction(required) : undefined);
    return (react_1.default.createElement("div", { className: classNamesForOuterDiv },
        react_1.default.createElement("label", { className: "small-2 medium", htmlFor: name }, label),
        react_1.default.createElement("div", { className: "input-wrapper-for-input-form" },
            react_1.default.createElement("input", Object.assign({}, register(name, registerOptions), { placeholder: placeholder, onFocus: () => setFocus(true), onBlur: () => setFocus(false) })),
            watchName && (react_1.default.createElement("img", { onClick: () => setValue(name, ''), className: 'remove-value', src: common_1.ICONS.close, alt: "close" }))),
        react_1.default.createElement(FieldErrorSectionForm_1.default, { name: name, assistiveText: displayAssistiveText, visibility: assistiveTextVisibility, required: required })));
};
exports.default = InputForm;
